<template>
  <div class="increase-edit-padding">
    <a-spin :spinning="loading">
      <a-skeleton v-show="loading" :paragraph="{rows: 10}" />
    </a-spin>
    <div v-show="!loading">
      <!-- 表单 -->
      <a-form :form="editForm" @submit="handleSubmit" autocomplete="off">
        <!-- 所属城市 -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="City"
        >
          <a-select
            show-search
            placeholder="Select a city"
            option-filter-prop="children"
            :filter-option="(input, option) => {
              return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0)
            }"
            v-decorator="[
              'cityId',
              {rules: [{ required: true, message: 'Please select a city.' }]}
            ]"
          >
            <a-select-option value="">No Select</a-select-option>
            <a-select-option v-for="c in cities" :key="c.id" :value="c.id">{{ c.nameEnUs }}</a-select-option>
          </a-select>
        </a-form-item>
        <!-- 名称-英文美国 -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Name(en-us)"
        >
          <a-input
            placeholder="Name(en-us)"
            v-decorator="[
              'nameEnUs',
              {rules: [{ required: true, message: 'Please input Name.' }]}
            ]"
          ></a-input>
        </a-form-item>
        <!-- 名称-中文繁体 -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Name(zh-tw)"
        >
          <a-input
            placeholder="Name(zh-tw)"
            v-decorator="[
              'nameZhTw',
              {rules: [{ required: false, message: 'Please input Name.' }]}
            ]"
          ></a-input>
        </a-form-item>
        <!-- 名称-中文简体 -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Name(zh-cn)"
        >
          <a-input
            placeholder="Name(zh-cn)"
            v-decorator="[
              'nameZhCn',
              {rules: [{ required: false, message: 'Please input Name.' }]}
            ]"
          ></a-input>
        </a-form-item>
        <!-- 所属城市 -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Title"
        >
          <a-select
            show-search
            placeholder="Select a title"
            option-filter-prop="children"
            :filter-option="(input, option) => {
              return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0)
            }"
            v-decorator="[
              'title',
              {rules: [{ required: true, message: 'Please select a title.' }]}
            ]"
          >
            <a-select-option value="MR">MR</a-select-option>
            <a-select-option value="MS">MS</a-select-option>
          </a-select>
        </a-form-item>
         <!-- 联络人名字 -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Contact Name"
        >
          <a-input
            placeholder="Contact Name"
            v-decorator="[
              'contact_name',
              {rules: [{ required: false, message: 'Please input Contact Name.' }]}
            ]"
          ></a-input>
        </a-form-item>
        <!-- 供应商地址 -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Address"
        >
          <a-input
            placeholder="Address"
            v-decorator="[
              'address',
              {rules: [{ required: false, message: 'Please input Address.' }]}
            ]"
          ></a-input>
        </a-form-item>
        <!-- 供应商邮编 -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Zip"
        >
          <a-input
            placeholder="Zip"
            v-decorator="[
              'zip',
              {rules: [{ required: false, message: 'Please input Zip.' }]}
            ]"
          ></a-input>
        </a-form-item>
        <!-- 供应商邮箱 -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Email"
        >
          <a-input
            placeholder="Email"
            v-decorator="[
              'email',
              {rules: [{ required: false, message: 'Please input Email.' }]}
            ]"
          ></a-input>
        </a-form-item>
         <!-- 供应商电话 -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Phone"
        >
          <a-input
            placeholder="Phone"
            v-decorator="[
              'phone',
              {rules: [{ required: false, message: 'Please input Phone.' }]}
            ]"
          ></a-input>
        </a-form-item>
         <!-- 供应商备注信息 -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Description"
        >
          <a-input
            placeholder="Description"
            v-decorator="[
              'description',
              {rules: [{ required: false, message: 'Please input Description.' }]}
            ]"
          ></a-input>
        </a-form-item>
        <!-- 启用标志 -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Eabled"
        >
          <a-switch
            v-decorator="[
              'enabledFlag',
              { valuePropName: 'checked' }
            ]"
          ></a-switch>
        </a-form-item>
        <!-- 隐藏域 -->
        <a-form-item v-show="false"><a-input
          v-decorator="[
          'id',
          {rules: [{ required: false}]}
          ]"/>
        </a-form-item>
      </a-form>
    </div>
    <footer-tool-bar>
      <a-button type="primary" html-type="submit" :loading="saving" @click="handleSubmit">Save</a-button>
      <a-button style="margin-left: 8px;" :loading="saving" @click="handleGoBack">Cancel</a-button>
    </footer-tool-bar>
  </div>
</template>

<script>
import pick from 'lodash.pick'
import CityApi from '@/api/basicdata/api-supplier'
import FooterToolBar from '@/components/FooterToolbar'

export default {
  name: 'SupplierEdit',
  components: {
    FooterToolBar
  },
  props: {
    record: {
      type: [String, Object],
      default: null
    },
    cities: {
      type: [Array],
      required: true
    },
  },
  data () {
    return {
      // 保存状态
      saving: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 24 }
        }
      },
      editForm: this.$form.createForm(this),
      createFlag: false,
      // 加载中
      loading: true
    }
  },
  mounted () {
    this.initData(this.record)
  },
  methods: {
    async initData (data) {
      this.loading = true
      var formData = null
      var createFlag = true
      if (data === '') {
        // 新增
        formData = { 'id': null, 'cityId': null, 'nameZhTw': null, 'nameZhCn': null, 'description':null,'title':null,'contact_name':null,'address':null,'zip':null,'email':null,'phone':null,'enabledFlag': true }
      } else {
        createFlag = false
        // 编辑
        formData = pick(data, ['id', 'cityId','nameEnUs', 'nameZhTw', 'nameZhCn', 'description','title','contact_name','address','zip','email','phone','enabledFlag'])
        if (formData.enabledFlag !== null && formData.enabledFlag === '1') {
          formData.enabledFlag = true
        } else {
          formData.enabledFlag = false
        }
      }
      this.createFlag = createFlag
      this.editForm.setFieldsValue(formData)
      this.loading = false
    },
    loadAllDeptList () {
      return CityApi.query(Object.assign({ curPage: 1, pageSize: 1000 }, {}))
    },
    handleGoBack () {
      this.$emit('onGoBack')
    },
    handleSubmit (e) {
      e.preventDefault()
      this.saving = true
      this.editForm.validateFields((err) => {
        // 如果校验失败直接返回
        if (err) {
          return
        }
        var formData = this.editForm.getFieldsValue()
        formData.enabledFlag = formData.enabledFlag ? '1' : '0'
        // 添加
        if (formData.id === null) {
          CityApi.add(formData).then(res => {
            if (!this.mixinProcessHasBizErrorNotification(res)) {
              this.mixinProcessSuccessNotification('Save successfully !')
              this.handleGoBack()
            }
          }).finally(() => {
            this.saving = false
          })
        }
        // 修改
        if (formData.id !== null) {
          CityApi.update(formData.id, formData).then(res => {
            if (!this.mixinProcessHasBizErrorNotification(res)) {
              this.mixinProcessSuccessNotification('Update successfully !')
              this.handleGoBack()
            }
          }).finally(() => {
            this.saving = false
          })
        }
      })
    }
  }
}
</script>
